
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 10"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M8.998.072C9.051.02 9.096 0 9.152 0c.054 0 .1.02.153.073l8.621 8.62c.054.055.074.1.074.156 0 .055-.02.1-.072.154l-.925.924c-.053.053-.099.073-.154.073-.055 0-.1-.02-.154-.073L9.152 2.384l-.272.272-7.275 7.273c-.051.052-.095.071-.151.071-.056 0-.1-.02-.154-.073l-.926-.924C.322 8.95.303 8.906.303 8.849c0-.056.02-.101.072-.155L8.998.072z"}})])
          )
        }
      }
    